import React, {useEffect, useState, useRef} from 'react'
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'
function InputComponent({ val, fun, title }) {
  return (
    <div className='col'>
      <label htmlFor="exampleFormControlTextarea1" className="form-label">{title}</label>
      <div className="input-group input-group-md mb-3">
        <input
        value={val}
          className="form-control"
          type="text"// Use the prop value to display the reason
          onChange={(e) => fun(e.target.value)} // Call the parent function to update the state
          required
        />
      </div>
    </div>
  );
}

export default function ClientDemoForm() {
    //all the states
    const [date, setDate] = useState('2023-08-09')
    const[reason, setReason] = useState()
    const [frustrationLevel, setFrustrationLevel] = useState()
    const [urgencyRequirement, setUrgencyRequirement] = useState()
    const [challengeDuration, setChallengeDuration] = useState()
    const [budget, setBudget] = useState()
    const [otOrS, setOtOrS] = useState()
    const [oTd, setOtd] = useState()
    const [jobTitle, setJobTitle] = useState()
    const [competition, setCompetition] = useState()
    const [company, setCompany] = useState()
    const [contactNumber, setContactNumber] = useState()
    const [assignedSalesperson, setAssignedSalesperson] = useState() 
    const [demoDay, setDemoDay] = useState()
    const [demoCompleted, setDemoCompleted] = useState()
    
    


    useEffect(() => {
        const today = new Date().toISOString().split('T')[0];
        setDate(today);
      }, []);




  const handleSubmit =  async (e) =>{
    e.preventDefault()
    const items = {why_are_you_here_today:reason, frustration_level: frustrationLevel, urgency_requirement: urgencyRequirement, 
      challenge_duration:challengeDuration, budget: budget, one_time_or_subscription: otOrS, open_to_demo:oTd,
    job_title: jobTitle, competition:competition, company: company, contact_number: contactNumber, assigned_salesperson: assignedSalesperson,
      demo_day: date, demo_completed: demoCompleted
  }
    const response = await fetch(`${process.env.REACT_APP_API_URL}/backend/demo-questions`,{
        method:"POST",
        headers:{
            "Content-Type":"application/json",
        },
        body:JSON.stringify(items)
    })
        // .then(console.log(items))
  }
  return (
    <>
    <div className="sidebar">
    <Sidebar/>
    </div>
    <div id='tabler'>
    <h1>Client Demo</h1>
      <form onSubmit={handleSubmit}>

        <div className="row">
        <div class="input-group input-group-md mb-3">
              <div className="mb-3">
        <label htmlFor="date" className="form-label">
          Date
        </label>
        <input
          id="num-value"
          type="date"
          className="form-control"
          min="0"
          required
          value={date || ""}
          onChange={(e) => {
            setDate(e.target.value)
           // console.log("Date changed")
          }}
        />
      </div></div>

      <InputComponent title={"Why are you here today?"} val={reason} fun={setReason}></InputComponent>
        </div>

        
              
          
          <InputComponent title={"Frustration level"} val={frustrationLevel} fun={setFrustrationLevel}></InputComponent>
          <InputComponent title={"Urgency Requirement"} val={urgencyRequirement} fun={setUrgencyRequirement}></InputComponent>
          <InputComponent title={"Challenge Duration"} val={challengeDuration} fun={setChallengeDuration}></InputComponent>
          <InputComponent title={"Budget"} val={budget} fun={setBudget}></InputComponent>
          <InputComponent title={"One time or Subscription"} val={otOrS} fun={setOtOrS}></InputComponent>
          <InputComponent title={"Are you open to demo?"} val={oTd} fun={setOtd}></InputComponent>
          <InputComponent title={"Job title"} val={jobTitle} fun={setJobTitle}></InputComponent>
          <InputComponent title={"Competition"} val={competition} fun={setCompetition}></InputComponent>
          <InputComponent title={"Company "} val={company} fun={setCompany}></InputComponent>
          <InputComponent title={"Contact Number"} val={contactNumber} fun={setContactNumber}></InputComponent>
          <InputComponent title={"Assigned Salesperson"} val={assignedSalesperson} fun={setAssignedSalesperson}></InputComponent>
          <InputComponent title={"Why are you here today?"} val={demoCompleted} fun={setDemoCompleted}></InputComponent>
              <button type="submit"className=" btn submit-btn">Submit</button>
      </form>
    </div>
    </>
    
  )
}
 